import Service from "../../../Services/index";
const driverBonus = {
    namespaced: true,
    state: {
        bonusList : [],
        bonusData : [],
        dataPaginate:{
            current_page :1,
            from : 1,
            last_page : 1,
            per_page : 1,
            total : 1,
            to : 1
        }
    },
    mutations: {
        SET_DRIVER_BONUS_LIST: (state, res) => {
            state.bonusList = res.data;
            state.dataPaginate = {
                current_page : res.current_page,
                from : res.form,
                last_page : res.last_page,
                per_page : res.per_page,
                total : res.total,
                to : res.to
            };
        },
        SET_DRIVER_BONUS_DATA :(state, res) => {
            state.bonusData = res;
        },
    },
    actions: {
        setDriverBonus({ commit },page=1) {
            return Service.DriverBonus.getDriverBonus(page)
                .then(data => {
                commit("SET_DRIVER_BONUS_LIST", data);
            });
        },
        show({ commit },id) {
            return Service.DriverBonus.showDriverBonus(id)
                .then(data => {
                    commit("SET_DRIVER_BONUS_DATA", data);
                });
        },
        save({ commit },{id,data}) {
            if(!id){
                return Service.DriverBonus.createDriverBonus(data);
            }else{
                return Service.DriverBonus.updateDriverBonus(id,data);
            }
        },
        delete({ commit },id) {
            return Service.DriverBonus.deleteDriverBonus(id)
        },
        search({commit},{page=1,data}){
            return Service.DriverBonus.searchDriverBonus(page,data)
                .then(res=>{
                    commit("SET_DRIVER_BONUS_LIST",res)
                });
        }
    }
};
export default driverBonus;